export default {
  roundID: 0,
  isProcess: false,
  gameStatus: 0,
  limits: {
    min: 0,
    max: 0,
    win: 0,
  },
  gameSettings: {
    amount: 0,
    riskLevel: 0,
    rowsCount: 8,
    ballsCount: 1,
},
  placedAmount: 0,
  coefficients: {},
  activeBalls: [],
  rtp: null,
  ballsHistory: [],
  colorTheme: 'orange',
  isHideMenu: false,
}